import {useSyncExternalStore} from 'react'
import {clsx} from 'clsx'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import styles from './ActionabilityBanner.module.css'

const LOADING_PHRASES = [
  'git blame-ing the delay…',
  'Traversing the commit graph…',
  'Reticulating CI pipelines…',
  "Deserializing your pull request's destiny…",
  'Garbage collecting stale opinions…',
  'Checking if the dog ate your approvals…',
  "Waiting for Schrödinger's CI to collapse into a state…",
  'Begging the automerge daemon for a straight answer…',
  'Asking git log --oneline for the meaning of life…',
  'Checking out your fate on a detached HEAD…',
]

const noopSubscribe = () => () => {}
const getLoadingPhrase = () => LOADING_PHRASES[new Date().getMinutes() % LOADING_PHRASES.length]
const getServerLoadingPhrase = () => LOADING_PHRASES[0]

export function ActionabilityBannerSkeleton() {
  const phrase = useSyncExternalStore(noopSubscribe, getLoadingPhrase, getServerLoadingPhrase)

  return (
    <div className={clsx(styles.banner, styles.loading)} data-testid="actionability-banner-loading">
      <div className={styles.text}>
        <LoadingSkeleton variant="rounded" height="sm" width="40%" className={styles.loadingLabel} />
        <span className={styles.loadingText}>{phrase}</span>
      </div>
      <LoadingSkeleton variant="rounded" height="32px" width="100%" className={styles.actionButton} />
    </div>
  )
}
